import { setOtpToken } from 'data-layer-cr/dist/authentication';
import qs from 'qs';
import {
  generateOtpToken,
  generatePrivateSeed,
} from 'data-layer-cr/dist/functions/encryption';

import AuthNetworkClient from './AuthNetworkClient';

let privateSeed = '';

export function getPrivateSeed(): string {
  if (privateSeed === '') {
    privateSeed = generatePrivateSeed({
      publicSeed: process.env.REACT_APP_PUBLIC_SEED as string,
      publicKey: process.env.REACT_APP_PUBLIC_KEY as string,
      hashStart: process.env.REACT_APP_HASH_START as string,
      hashEnd: process.env.REACT_APP_HASH_END as string,
    });
  }
  return privateSeed;
}

export default async function fetchOtpAccessToken(): Promise<string> {
  try {
    const otpToken = generateOtpToken(getPrivateSeed());

    const response = await AuthNetworkClient({
      url: '/connect/token?authType=otp',
      method: 'POST',
      data: qs.stringify({
        grant_type: 'password',
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET,
        username: process.env.REACT_APP_CLIENT_USERNAME,
        password: otpToken,
      }),
    });

    const { access_token: accessToken } = response.data;
    setOtpToken(accessToken);
    return accessToken;
  } catch (e) {
    return '';
  }
}
